import {
  FETCH_RAW_STOCK_HISTORY_REQUEST,
  FETCH_RAW_STOCK_HISTORY_SUCCESS,
  FETCH_RAW_STOCK_HISTORY_FAILURE,
  FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_REQUEST,
  FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_SUCCESS,
  FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_FAILURE,
  FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_REQUEST,
  FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_SUCCESS,
  FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_FAILURE,
  FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_REQUEST,
  FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_SUCCESS,
  FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_FAILURE,
  CREATE_RAW_STOCK_HISTORY_REQUEST,
  CREATE_RAW_STOCK_HISTORY_SUCCESS,
  CREATE_RAW_STOCK_HISTORY_FAILURE,
  GET_RAW_STOCK_HISTORY_REPORT_REQUEST,
  GET_RAW_STOCK_HISTORY_REPORT_SUCCESS,
  GET_RAW_STOCK_HISTORY_REPORT_FAILURE
} from '../../actions/rawStockHistory/rawStockHistoryActionTypes';

const initialState = {
  rawStockHistory: [],
  rawStockHistoryByStockCode: [],
  rawStockHistoryByDateRange: [],
  rawStockHistoryByCreatedBy: [],
  rawStockHistoryReport: { rows: [], totals: {} },
  loading: false,
  error: null,
  reportLoading: false,
  reportError: null
};

const rawStockHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch all raw stock history
    case FETCH_RAW_STOCK_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_RAW_STOCK_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        rawStockHistory: action.payload,
        error: null
      };
    case FETCH_RAW_STOCK_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Fetch raw stock history by stock code
    case FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        rawStockHistoryByStockCode: action.payload,
        error: null
      };
    case FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Fetch raw stock history by date range
    case FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_SUCCESS:
      return {
        ...state,
        loading: false,
        rawStockHistoryByDateRange: action.payload,
        error: null
      };
    case FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Fetch raw stock history by created by
    case FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_SUCCESS:
      return {
        ...state,
        loading: false,
        rawStockHistoryByCreatedBy: action.payload,
        error: null
      };
    case FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Create raw stock history
    case CREATE_RAW_STOCK_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case CREATE_RAW_STOCK_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        rawStockHistory: [action.payload, ...state.rawStockHistory],
        error: null
      };
    case CREATE_RAW_STOCK_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Get raw stock history report
    case GET_RAW_STOCK_HISTORY_REPORT_REQUEST:
      return {
        ...state,
        reportLoading: true,
        reportError: null
      };
    case GET_RAW_STOCK_HISTORY_REPORT_SUCCESS:
      return {
        ...state,
        reportLoading: false,
        rawStockHistoryReport: action.payload,
        reportError: null
      };
    case GET_RAW_STOCK_HISTORY_REPORT_FAILURE:
      return {
        ...state,
        reportLoading: false,
        reportError: action.payload
      };

    default:
      return state;
  }
};

export default rawStockHistoryReducer; 